module.exports = __webpack_public_path__ + "img/组 4.355fd3a1.webp";